import { render } from "./blog.vue?vue&type=template&id=51abd738"
import script from "./blog.vue?vue&type=script&lang=ts"
export * from "./blog.vue?vue&type=script&lang=ts"

import "./blog.vue?vue&type=style&index=0&id=51abd738&lang=scss"
script.render = render

export default script